import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class CaseService {

  detailReload$ = new Subject<any>();

  detailReload() {
    this.detailReload$.next(true);
  }

}
